import React, { useCallback, useMemo, useState } from "react";
import { translateText } from "../../../../shared/utils/historyTranslation";
import {
  fmtNum,
  getCageShortTag,
} from "../utils/summaryDashboardV3Utils";

export const SummaryV3Tooltip = React.memo(function SummaryV3Tooltip({
  value,
  title,
  rows = [],
  extraRows = [],
  size = "default",
  translate,
}) {
  const t = useCallback((key, fallback) => translateText(translate, key, fallback), [translate]);
  const [showAll, setShowAll] = useState(false);
  const visibleRows = useMemo(() => (showAll ? [...rows, ...extraRows] : rows), [showAll, rows, extraRows]);
  const handleToggleRows = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowAll((current) => !current);
  }, []);

  return (
    <span className={`summary-v3__tooltipHost summary-v3__tooltipHost--${size}`} tabIndex={0}>
      <span className="summary-v3__tooltipValue">{value}</span>
      <span className="summary-v3__tooltipBox" role="tooltip">
        <strong>{title}</strong>
        {visibleRows.length ? (
          <span className="summary-v3__tooltipRows">
            {visibleRows.map(([label, detail], index) => (
              <span key={`${label}-${detail}-${index}`} className="summary-v3__tooltipRow">
                <span>{label}</span>
                <em>{detail}</em>
              </span>
            ))}
          </span>
        ) : (
          <span className="summary-v3__tooltipEmpty">{t("summary_v3_no_records", "Sin registros")}</span>
        )}
        {extraRows.length ? (
          <button
            type="button"
            className="summary-v3__tooltipMore"
            onClick={handleToggleRows}
          >
            {showAll
              ? t("summary_v3_show_less_records", "Ver menos registros")
              : `${t("summary_v3_show_more_records", "Ver mas registros")} (+${extraRows.length})`}
          </button>
        ) : null}
      </span>
    </span>
  );
});

export const SummaryV3CageListTooltip = React.memo(function SummaryV3CageListTooltip({
  value,
  title,
  cages,
  size = "default",
  translate,
}) {
  const { rows, extraRows } = useMemo(() => {
    const toRow = (cage) => [
      `${translateText(translate, "jaula", "Jaula")} ${cage.alias}`,
      [
        // `O2 ${fmtNum(cage.o2)} /  Min ${fmtNum(cage.threshold)} /  Max ${fmtNum(cage.highThreshold)} / ${getCageShortTag(cage)}`,
        `O2 ${fmtNum(cage.o2)} / ${getCageShortTag(cage, translate)}`,
        cage.visibleSensorProblemLabel,
      ].filter(Boolean).join(" / "),
    ];

    return {
      rows: cages.slice(0, 6).map(toRow),
      extraRows: cages.slice(6).map(toRow),
    };
  }, [cages, translate]);

  return (
    <SummaryV3Tooltip
      value={value}
      title={title}
      rows={rows}
      extraRows={extraRows}
      size={size}
      translate={translate}
    />
  );
});
